<template>
    <modal :containerClass="'w-30'">
        <div class="modal-contour vertical-center" :class="'border-' + theme">
            <div class="p-0 form-group text-center">
                <h4 class="text-bold m-0" :class="'text-' + theme" v-html="msg"></h4>
                <slot></slot>
            </div>
        </div>
        <div class="col-sm-12 buttons-container">
            <div class="col-sm-6">
                <span class="btn-container">
                    <a class="btn btn-success btn-white-bg text-success btn-sm btn-round"
                       v-if="inverted" @click="runAction()" v-bind="loading ? {disabled: true} : {}">
                        <i class="fa fa-circle-o-notch fa-spin" v-if="loading"></i> Sim</a>
                    <a class="btn btn-danger btn-sm btn-round" v-else @click="$emit('close')">Não</a>
                </span>
            </div>
            <div class="col-sm-6 text-right">
                <span class="btn-container">
                    <a class="btn btn-danger btn-sm btn-round" v-if="inverted" @click="$emit('close')">Não</a>
                    <a class="btn btn-success btn-sm btn-round" @click="runAction()" v-else
                       v-bind="loading ? {disabled: true} : {}">
                        <i class="fa fa-circle-o-notch fa-spin" v-if="loading"></i> Sim</a>
                </span>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "./Modal";
    export default {
        name: "ModalConfirm",
        components: {Modal},
        props: ['inverted', 'theme', 'action', 'async', 'msg'],
        data() {
            return {loading: false}
        },
        methods: {
            runAction() {
                if (this.action) {
                    if (this.async) {
                        this.loading = true;
                        this.action().finally(() => {
                            this.loading = false; this.$emit('close');
                        });
                    } else {
                        this.action();
                        this.$emit('close');
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .buttons-container {
        margin-top: -15px;
    }

    .btn-container {
        padding: 10px;
        background-color: white;
    }

    .text-success {
        color: #5cc691 !important;
    }

    .text-orange {
        color: #ec8009;
    }

    .border-orange {
        border-color: #ec8009;
    }
</style>